import { BAOCustomElement } from '@bao/custom-element'

class ProductReviewsDrawer extends BAOCustomElement() {
  setupListeners () {
    super.setupListeners()

    const interval = setInterval(() => {
      const ratingSnippetEl = this.querySelector('.ruk_rating_snippet')
      if (!ratingSnippetEl) return

      const ratingSnippetCountEl = ratingSnippetEl.querySelector(
        '.ruk-rating-snippet-count',
      )

      if (!ratingSnippetCountEl) return

      clearInterval(interval)

      let count = ratingSnippetCountEl.innerText
        ?.toLowerCase()
        ?.replace('(', '')
        ?.replace(')', '')
        ?.replace('review', '')
        ?.replace('reviews', '')

      count = count[0]

      if (!isNaN(count)) {
        count = Number(count)

        if (count !== 0) {
          this.removeAttribute('hidden', '')
        }
      }
    }, 250)
  }
}

if (!customElements.get('product-reviews-drawer')) {
  customElements.define('product-reviews-drawer', ProductReviewsDrawer)
}
